import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

export const showPasswordIconStyles = {
  color: 'secondary.contrastText',
  fontSize: 16
}

const useStyles = makeStyles((theme: Theme) => ({
  forgotPassword: {
    marginTop: `40px !important`,
    padding: `0px !important`
  },
  iconButton: {
    backgroundColor: `transparent !important`
  },
  width100: {
    width: '100%'
  }
}))

export default useStyles
